import * as fromDatatype from '../datatype-library/index';

export interface bl_alg_cc_outbound_task_queue_hdr_RowInterface {
  guid : fromDatatype.GuidDataFieldInterface;
  agent_guid : fromDatatype.GuidDataFieldInterface;
  login_subject_guid : fromDatatype.GuidDataFieldInterface;
  group_hdr_guid : fromDatatype.GuidDataFieldInterface;
  outbound_task_hdr_guid : fromDatatype.GuidDataFieldInterface;
  insert_time : fromDatatype.TimestampTzDatatypeInterface;
  start_time : fromDatatype.TimestampTzDatatypeInterface;
  expire_time : fromDatatype.TimestampTzDatatypeInterface;
  event_code : fromDatatype.VarcharDatatypeClass;
  priority: fromDatatype.IntegerDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid : fromDatatype.GuidDataFieldInterface;
  applet_guid : fromDatatype.VarcharDatatypeInterface;
  name : fromDatatype.VarcharDatatypeInterface;
  code : fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  property_json : fromDatatype.JsonDatatypeInterface;
  acl_config : fromDatatype.JsonDatatypeInterface;
  acl_policy : fromDatatype.JsonDatatypeInterface;
  created_date : fromDatatype.TimestampTzDatatypeInterface;
  updated_date : fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid : fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid : fromDatatype.GuidDataFieldInterface;
  status : fromDatatype.StatusDataFieldInterface;
  revision : fromDatatype.GuidDataFieldInterface;
  vrsn : fromDatatype.VarcharDatatypeInterface;
}

export class bl_alg_cc_outbound_task_queue_hdr_RowClass implements bl_alg_cc_outbound_task_queue_hdr_RowInterface {
  guid : fromDatatype.GuidDataFieldInterface;
  agent_guid : fromDatatype.GuidDataFieldInterface;
  login_subject_guid : fromDatatype.GuidDataFieldInterface;
  group_hdr_guid : fromDatatype.GuidDataFieldInterface;
  outbound_task_hdr_guid : fromDatatype.GuidDataFieldInterface;
  insert_time : fromDatatype.TimestampTzDatatypeInterface;
  start_time : fromDatatype.TimestampTzDatatypeInterface;
  expire_time : fromDatatype.TimestampTzDatatypeInterface;
  event_code : fromDatatype.VarcharDatatypeClass;
  priority: fromDatatype.IntegerDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid : fromDatatype.GuidDataFieldInterface;
  applet_guid : fromDatatype.VarcharDatatypeInterface;
  name : fromDatatype.VarcharDatatypeInterface;
  code : fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  property_json : fromDatatype.JsonDatatypeInterface;
  acl_config : fromDatatype.JsonDatatypeInterface;
  acl_policy : fromDatatype.JsonDatatypeInterface;
  created_date : fromDatatype.TimestampTzDatatypeInterface;
  updated_date : fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid : fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid : fromDatatype.GuidDataFieldInterface;
  status : fromDatatype.StatusDataFieldInterface;
  revision : fromDatatype.GuidDataFieldInterface;
  vrsn : fromDatatype.VarcharDatatypeInterface;
}
